export const subfoldersMapping: any = {
  "owner-representative": "Representante del Propietario",
  "owner-representative-pm": "Representante del Propietario",
  "landlord-pf": "Documentos del Propietario",
  "landlord-pm": "Documentos del Propietario",
  "guarantor-pf-cja": "Fiador PF - CJA",
  "guarantor-pm-cja": "Fiador PM - CJA",
  "tenant-pm-cja": "Inquilino PM - CJA",
  "tenant-pf-cja": "Inquilino PF - CJA",
  "lease-contract-pm": "Contrato Arrendamiento PM",
  "lease-contract-pf": "Contrato Arrendamiento PF",
  collateral: "Inmueble en Garantía",
  "guarantor-investigation-pm": "Fiador PM Investigacion",
  "guarantor-investigation-pf": "Fiador PF Investigacion",
  "guarantor-pm": "Fiador PM",
  "guarantor-pf": "Fiador PF",
  "tenant-pm": "Inquilino PM",
  "tenant-pf": "Inquilino PF",
};

export const subfoldersOrder: string[] = Object.keys(subfoldersMapping).map(
  (template: any) => template,
);
